import * as types from './types'

export default {
  [types.REQUEST_AUDIO](state) {
    const count = state.activeAudioRequests + 1
    state.activeAudioRequests = count
  },

  [types.REQUESTED_AUDIO](state) {
    const count = state.activeAudioRequests - 1
    state.activeAudioRequests = count
  },

  [types.REQUEST_VIDEO](state) {
    const count = state.activeVideoRequests + 1
    state.activeVideoRequests = count
  },

  [types.REQUESTED_VIDEO](state) {
    const count = state.activeVideoRequests - 1
    state.activeVideoRequests = count
  },

  [types.REQUEST_IMAGE](state) {
    const count = state.activeImageRequests + 1
    state.activeImageRequests = count
  },

  [types.REQUESTED_IMAGE](state) {
    const count = state.activeImageRequests - 1
    state.activeImageRequests = count
  },

  [types.REQUEST_AJAX](state) {
    const count = state.activeAjaxRequests + 1
    state.activeAjaxRequests = count
  },

  [types.REQUESTED_AJAX](state) {
    const count = state.activeAjaxRequests - 1
    state.activeAjaxRequests = count
  },

  [types.SET_LOCALE](state, locale) {
    state.locale = locale
  },

  [types.RECEIVE_CONTENT](state, {content}) {
    state.content = content
  },

  [types.PRELOADED_ASSETS](state, asset) {
    state.preloadedAssets = {...state.preloadedAssets, ...asset}
  },
  updateTrackingData(state, payload) {
    const updatedTrackingData = {...state.trackingData}
    updatedTrackingData.isMedia = payload.isMedia
    updatedTrackingData.mediaType = payload.mediaType
    updatedTrackingData.mediaKey = payload.mediaKey
    state.trackingData = updatedTrackingData
  }
}
